import { KText } from '@/ui-library/components';
import {
  CreatedBy,
  CreditedTo,
  DepartmentName,
  HiringManagers,
  JobName,
  NameCell,
  OfficeName,
  Recruiters,
  SourceName,
  StageName,
  WorkType,
  Workplace,
} from '../cells/PipelineDrilldownCells';

const renderDrilldownHeader = (title: string) => () => (
  <KText size="sm-medium" color="secondary-900" textTransform="none">
    {title}
  </KText>
);

export const usePipelineDrilldownConfig = ({
  drilldownHeading: _drilldownHeading = 'Pipeline',
}) => {
  const getColumnConfig = () => {
    const columnsMap = {
      applicantName: {
        title: 'Applicant name',
        Header: renderDrilldownHeader('Applicant name'),
        id: 'candidate_name',
        width: 220,
        accessor: 'name',
        sort: true,
        filterable: true,
        columnConfig: false,
        Cell: ({ row }) => NameCell(row),
      },
      jobName: {
        title: 'Job name',
        Header: renderDrilldownHeader('Job name'),
        width: 200,
        accessor: 'job_name',
        sort: true,
        filterable: true,
        Cell: ({ row }) => JobName(row),
      },
      sourceName: {
        title: 'Source',
        Header: renderDrilldownHeader('Source'),
        minWidth: 200,
        accessor: 'source_name',
        id: 'appl_contact_source',
        sort: true,
        Cell: ({ row }) => SourceName(row),
      },
      creditedTo: {
        title: 'Credited to',
        Header: renderDrilldownHeader('Credited to'),
        minWidth: 200,
        accessor: 'credited_to',
        sort: true,
        Cell: ({ row }) => CreditedTo(row),
      },
      createdBy: {
        title: 'Application creator',
        Header: renderDrilldownHeader('Application creator'),
        minWidth: 200,
        accessor: 'application_creator',
        sort: true,
        Cell: ({ row }) => CreatedBy(row),
      },
      recruiters: {
        title: 'Recruiters',
        Header: renderDrilldownHeader('Recruiters'),
        minWidth: 220,
        accessor: 'recruiters',
        sort: true,
        Cell: ({ row }) => Recruiters(row),
      },
      hiringManagers: {
        title: 'Hiring managers',
        Header: renderDrilldownHeader('Hiring managers'),
        minWidth: 220,
        accessor: 'hiring_managers',
        sort: true,
        Cell: ({ row }) => HiringManagers(row),
      },
      departmentName: {
        title: 'Department',
        Header: renderDrilldownHeader('Department'),
        minWidth: 200,
        accessor: 'department_name',
        sort: true,
        Cell: ({ row }) => DepartmentName(row),
      },
      officeName: {
        title: 'Offices',
        Header: renderDrilldownHeader('Offices'),
        minWidth: 220,
        accessor: 'offices',
        sort: true,
        Cell: ({ row }) => OfficeName(row),
      },
      stageName: {
        title: 'Stage name',
        Header: renderDrilldownHeader('Stage name'),
        minWidth: 200,
        accessor: 'stage_name',
        sort: true,
        Cell: ({ row }) => StageName(row),
      },
      workplace: {
        title: 'Workplace',
        Header: renderDrilldownHeader('Workplace'),
        minWidth: 200,
        accessor: 'workplace',
        sort: true,
        Cell: ({ row }) => Workplace(row),
      },
      workType: {
        title: 'Work type',
        Header: renderDrilldownHeader('Work type'),
        minWidth: 200,
        accessor: 'work_type',
        sort: true,
        Cell: ({ row }) => WorkType(row),
      },
    };

    return [
      columnsMap.applicantName,
      columnsMap.sourceName,
      columnsMap.creditedTo,
      columnsMap.createdBy,
      columnsMap.jobName,
      columnsMap.stageName,
      columnsMap.recruiters,
      columnsMap.hiringManagers,
      columnsMap.departmentName,
      columnsMap.officeName,
      columnsMap.workplace,
      columnsMap.workType,
    ];
  };

  return { columnConfig: getColumnConfig() };
};
